class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.config = JSON.parse(this.querySelector('.config').textContent);
        this.next = this.querySelectorAll('.next');
        console.log(this.config);
    }
    connectedCallback() {
        this.slider = new Swiper(this, this.config);
        this.next.forEach(e => e.addEventListener('click', () => this.slider.slideNext()))
        this.slider.on('slideChange', function () {
            console.log('slide changed');
          });
    }
}

if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', SwiperSlider)
}